var React = require('react');

function AppleInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"className":"st0","d":"M49.1,9.5C56.4,0,66.4,0,66.4,0s1.5,9-5.7,17.6c-7.7,9.2-16.4,7.7-16.4,7.7S42.7,18,49.1,9.5z"})),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M45.3,31.5c3.7,0,10.6-5.1,19.6-5.1c15.5,0,21.6,11,21.6,11s-11.9,6.1-11.9,20.9c0,16.7,14.8,22.4,14.8,22.4\n\t\t\t\tS79,109.9,65,109.9c-6.4,0-11.4-4.3-18.2-4.3c-6.9,0-13.8,4.5-18.2,4.5C15.8,110-0.4,82.4-0.4,60.1c0-21.9,13.7-33.4,26.5-33.4\n\t\t\t\tC34.5,26.7,40.9,31.5,45.3,31.5z"}))])));
}

AppleInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 89 110","style":{"enableBackground":"new 0 0 89 110"},"xmlSpace":"preserve"};

module.exports = AppleInline;

AppleInline.default = AppleInline;
